import React from 'react'
import * as urls from '../../constants/urls'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'

export default ({ open, onAccept, onCancel }) => (
	<Dialog open={open} maxWidth="xs">
		<DialogTitle>
			Användning av cookies
		</DialogTitle>
		<DialogContent>
			<DialogContentText>
				Vi använder nödvändiga cookies för att vår webbplats ska fungera. Vi vill också spara cookies för statistik.
			Statistiken hjälper oss förstå hur besökare interagerar med webbplatsen. Se <a href={urls.LM_COOKIE_INFO} rel="noopener noreferrer" target="_blank">Lantmäteriets sida om cookies</a>.
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={onCancel} color="primary">Neka</Button>
			<Button onClick={onAccept} variant="contained" color="primary" autoFocus>Tillåt</Button>
		</DialogActions>
	</Dialog>
)



// WEBPACK FOOTER //
// ./src/components/LegalDialog/LegalDialog.js